import React from 'react';

/**
 * Skeleton do drill-down do aluno (PanelStudent) — <b>parcial e honesto</b>.
 *
 * <p><b>Auto-contido:</b> inline styles + tokens globais (Shell.css é
 * eager-loaded). NÃO reusa `.pnls-*` do PanelStudent.css porque essa CSS é
 * lazy — quando este skeleton renderiza como Suspense fallback (primeira
 * visita à rota), o chunk do PanelStudent ainda não chegou; classes viriam
 * sem estilo.
 *
 * <p><b>Corte deliberado:</b> este skeleton mostra <b>apenas hero card e
 * timeline card</b>. O `.pnls-col2` do drill-down real — que contém
 * `<WeekPlanCard>` (0-N cards de plano semanal com itens variáveis) +
 * `<RecentActivityCard>` — <b>NÃO ENTRA</b>. Motivo: REDLINE §4 corolário —
 * "skeleton que não bate com o layout real é pior que spinner: promete uma
 * forma e entrega outra, com layout shift na hora que os dados chegam".
 * Shape dos cards de plano semanal varia por aluno (semanas sem plano, com
 * 1 item, com 5 itens) — reintroduzir causa salto visível na troca
 * skeleton→real. Se o dev futuro quiser "completar" o skeleton, precisa
 * PRIMEIRO estabilizar a geometria (ex.: sempre N cards mesmo que vazios).
 *
 * <p>⚠️ <b>A faixa de eventos (16/08) NÃO entra, pelo mesmo motivo.</b> Ela só
 * existe em AULA PARTICULAR — o servidor manda `weekEvents: null` em turma
 * normal —, então desenhá-la prometeria uma seção que não vem na maioria dos
 * casos. Mesma régua do `.pnls-col2`: skeleton que não bate com o layout real
 * é pior que spinner.
 *
 * <p>⚠️ <b>O chip de nascimento cabe na linha logística</b> que já existe: ele
 * aparece SEMPRE (mesmo sem data preenchida), então o slot é estável — é o
 * único dos quatro chips do hero que não some.
 *
 * <p><b>Anatomia (bate byte-a-byte com PanelStudent.css):</b>
 * <ul>
 *   <li>Hero card — padding 20×22, border ink-100 radius 15, mb 18. Avatar 60
 *   círculo + linhas nome/tag + 4 chips logísticos (radius 8, padding 6×11).
 *   <li>Timeline card — padding 18×20, border ink-100 radius 16. Título +
 *   WeekRoller com 7 pills shimmer.
 * </ul>
 */
export default function PanelStudentSkeleton() {
	return (
		<div aria-busy="true" aria-live="polite">
			{/* Hero card */}
			<div
				aria-hidden="true"
				style={{
					background: 'var(--paper)',
					border: '1px solid var(--ink-100)',
					borderRadius: 15,
					padding: '20px 22px',
					marginBottom: 18,
					boxShadow: '0 1px 3px rgba(0,0,0,.04)',
				}}
			>
				<div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
					<span className="sk skc" style={{ width: 60, height: 60, flexShrink: 0 }} />
					<div style={{ flex: 1, minWidth: 0 }}>
						<span className="sk" style={{ width: 220, height: 24, display: 'block' }} />
						<span className="sk" style={{ width: 140, height: 13, display: 'block', marginTop: 6 }} />
					</div>
				</div>
				<div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 15 }}>
					{[110, 130, 90, 120].map((w, i) => (
						<span key={i} className="sk" style={{ width: w, height: 30, borderRadius: 8 }} />
					))}
				</div>
			</div>

			{/* Timeline card */}
			<div
				aria-hidden="true"
				style={{
					background: 'var(--paper)',
					border: '1px solid var(--ink-100)',
					borderRadius: 16,
					padding: '18px 20px',
					marginBottom: 18,
				}}
			>
				<div style={{ marginBottom: 14 }}>
					<span className="sk" style={{ width: 140, height: 14 }} />
				</div>
				<div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
					{Array.from({ length: 7 }).map((_, i) => (
						<span
							key={i}
							className="sk"
							style={{ flex: 1, height: 44, borderRadius: 10 }}
						/>
					))}
				</div>
			</div>
		</div>
	);
}
